import { FC } from "react";
import { StoreCouponModel } from "../../models";
import { CircleFill, Copy } from "react-bootstrap-icons";
// import { HiOutlineShieldCheck } from "react-icons/hi2";
import { formatCurrency } from "../../utilities";
import { Toast } from "../Toast";
import { sanitizeHtml } from "../../helpers";

type Props = {
  coupon: StoreCouponModel;
  copy?: boolean;
  apply?: boolean;
  handleApply?: (code: string) => void;
};

const CouponCard: FC<Props> = ({
  coupon,
  copy = true,
  apply = false,
  handleApply = () => {},
}) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(coupon.code);
    Toast.success("Copied Successfully");
  };

  return (
    <>
      {/* <li className="d-flex flex-row justify-content-between align-items-center bg-white p-3 rounded">
        <span>
          <abbr className="text-uppercase">
            <img src={toAbsoluteUrl("images/image10.png")} alt="" />
            {coupon.code}</abbr>
          <h5>{coupon.title}</h5>
          <p>{coupon.description}</p>
          <small>Expire on <i>{coupon.expire_at}</i></small>
        </span>
        <span>
          {!apply && copy && <button className="btn copy-btn btn-sm" onClick={handleCopy}><Copy /> Copy</button>}
          {apply && <button className="btn apply-btn btn-sm" onClick={() => handleApply(coupon.code)}>Apply</button>}
        </span>
      </li> */}

      <li className="coupon-card-compo">
        {!apply && copy && (
          <div className="coupon-ribbon">
            BEST VALUE
            <span className="coupon-ribbon-shadow"></span>
          </div>
        )}

        <div className="coupon-shape">
          <div className="coupon-corner-top-left"></div>
          <div className="coupon-corner-bottom-right"></div>
          <div className="coupon-content">
            <div className="coupon-top">
              <div className="couopn-content-card">
                <h3 className="coupon-code">{coupon.code}</h3>

                {!apply && copy && (
                  <h5 className="coupon-title">{coupon.title}</h5>
                )}

                <p
                  className="coupon-description"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(coupon.description),
                  }}
                />
              </div>
              <span>
                {!apply && copy && (
                  <button className="btn coupon-copy-btn" onClick={handleCopy}>
                    Copy Code <Copy className="mx-2" />
                  </button>
                )}
                {apply && (
                  <button
                    className="btn coupon-copy-btn"
                    onClick={() => handleApply(coupon.code)}
                  >
                    Apply Code
                  </button>
                )}
              </span>
            </div>

            {!apply && copy && <div className="coupon-divider"></div>}
            {!apply && copy && (
              <div className="coupon-footer">
                <div className="coupon-meta">
                  {Number(coupon.min_cart_value) > 0 && (
                    <>
                      Min. order{" "}
                      <span>
                        {formatCurrency(Number(coupon.min_cart_value))}
                      </span>
                    </>
                  )}

                  {Number(coupon.max_discount) > 0 && (
                    <>
                      {Number(coupon.min_cart_value) > 0 && (
                        <span className="dot">
                          <CircleFill size={6} />
                        </span>
                      )}
                      Max. discount{" "}
                      {formatCurrency(Number(coupon.max_discount))}
                    </>
                  )}
                </div>

                <div className="coupon-validity">
                  <small>
                    {" "}
                    Valid till <i>{coupon.expire_at}</i>
                  </small>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* {!apply && copy && (
          <div className="coupon-bottom-text">
            <span>
              <HiOutlineShieldCheck size={22} /> One use per customer{" "}
            </span>
            <span className="dot">
              <CircleFill size={6} />
            </span>
            <span> Not valid on combo offers </span>
          </div>
        )} */}
      </li>
    </>
  );
};

export default CouponCard;
